import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <div className="relative flex min-h-[70vh] flex-col items-center justify-center px-4 text-center">
        <span className="text-7xl font-black text-primary-100 md:text-9xl">404</span>
        <h1 className="mt-4 text-xl font-bold text-foreground-950 md:text-2xl">页面不存在</h1>
        <p className="mt-2 font-mono text-sm text-foreground-500">{location.pathname}</p>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          你访问的页面可能已被移除或链接有误，可以返回首页浏览最新与热门作品，或直接搜索想看的影片。
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-primary-600"
          >
            <i className="ri-home-5-line text-base" aria-hidden="true" />
            返回首页
          </Link>
          <Link
            to="/search"
            className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors duration-200 hover:border-primary-300 hover:text-primary-600"
          >
            <i className="ri-search-line text-base" aria-hidden="true" />
            搜索影片
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}